// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FeedSetupController from "./feed_setup_controller.js"
application.register("feed-setup", FeedSetupController)

import FeedsController from "./feeds_controller.js"
application.register("feeds", FeedsController)

import FeedSourcePickerController from "./feed_source_picker_controller.js"
application.register("feed-source-picker", FeedSourcePickerController)

import FeedsTableController from "./feeds_table_controller.js"
application.register("feeds-table", FeedsTableController)

import JqueryDatatableController from "./jquery_datatable_controller.js"
application.register("jquery-datatable", JqueryDatatableController)

import AdminDashboardController from "./admin_dashboard_controller.js"
application.register("admin-dashboard", AdminDashboardController)

import ApiDashboardController from "./api_dashboard_controller.js"
application.register("api-dashboard", ApiDashboardController)

import ProductDashboardController from "./product_dashboard_controller.js"
application.register("product-dashboard", ProductDashboardController)

import NfrMenuController from "./nfr_menu_controller.js"
application.register("nfr-menu", NfrMenuController)

import MobileAppPromoController from "./mobile_app_promo_controller.js"
application.register("mobile-app-promo", MobileAppPromoController)

import ReaderActivityController from "./reader_activity_controller.js"
application.register("reader-activity", ReaderActivityController)

import DesktopAppPromoController from "./desktop_app_promo_controller.js"
application.register("desktop-app-promo", DesktopAppPromoController)

import InlineEditController from "./inline_edit_controller.js"
application.register("inline-edit", InlineEditController)

import AutoSubmitController from "./auto_submit_controller.js"
application.register("auto-submit", AutoSubmitController)

import PollController from "./poll_controller.js"
application.register("poll", PollController)

import CoverageDrawerController from "./coverage_drawer_controller.js"
application.register("coverage-drawer", CoverageDrawerController)

import DismissibleController from "./dismissible_controller.js"
application.register("dismissible", DismissibleController)

import FrameDialogController from "./frame_dialog_controller.js"
application.register("frame-dialog", FrameDialogController)

import ConditionalFieldsController from "./conditional_fields_controller.js"
application.register("conditional-fields", ConditionalFieldsController)

import UnsavedChangesController from "./unsaved_changes_controller.js"
application.register("unsaved-changes", UnsavedChangesController)

import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)

import SubmissionFocusController from "./submission_focus_controller.js"
application.register("submission-focus", SubmissionFocusController)
